import { useProductsStore } from "@/utils/stores/useProductsStore"

export const useDnaTest = () => {
    const { productsData } = useProductsStore()
    const dnaTestUser = productsData.dnaTest != null ? true : false
    return { dnaTestUser }
}